module.exports = __webpack_public_path__ + "img/alert-circle-outline.709833dc.svg";